import React from 'react';
import { useField, FieldInputProps } from 'formik';
import { TextInput, TextInputProps } from '@guildeducationinc/recess';
import '../FormInputFields.scss';

/**
 * Formik Field wrapper for Recess 'TextInput'. This requires a few props from Formik to be passed in.
 *
 * @example
 * ```jsx
 * <TextInputField
 *   label={label}
 *   name={name}
 *   onBlur={handleBlur}
 *   onChange={handleChange}
 *   placeholder={placeholder}
 *   value={values.first_name}
 * />
 * ```
 * Note: 'label', 'name' and 'placeholder' are our custom values, whereas
 * 'handleBlur', 'handleChange' and 'values' come from Formik props.
 *
 * @packageDocumentation
 */

type BaseInputProps = FieldInputProps<string> & TextInputProps;
type TextInputFieldProps = BaseInputProps;

const TextInputField: React.FC<TextInputFieldProps> = (props) => {
  const [field, { error, touched }] = useField(props as any);

  return (
    <TextInput
      {...field}
      {...props}
      errors={touched && error ? error : props.errors}
      value={field.value || ''}
      aria-live='assertive'
    />
  );
};

export default TextInputField;
